import { render, staticRenderFns } from "./RequestWorkPackageGroupInclusionMode.vue?vue&type=template&id=54ab5890&"
import script from "./RequestWorkPackageGroupInclusionMode.vue?vue&type=script&lang=js&"
export * from "./RequestWorkPackageGroupInclusionMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardActions,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QCardActions,QBtn,QTooltip}, component.options.components || {})
